import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import BlogService from '../services/blog.service'
import {escapeTurkishCharsAndLowerForURL, izBlank, LOG_OUT} from "../constants";
import {UserAction} from "../actions/UserAction";
import AuthService from "../services/auth.service";
import {Button, Input, message, Popconfirm, Switch} from "antd";
import i18n from "i18next";
import {EditOutlined, LinkOutlined} from "@ant-design/icons";
import CKEditor from 'ckeditor4-react';
import Blogs from "./Blogs";
import Language from "./Language";
import PictureUploader from "./PictureUploader";

const {TextArea} = Input;

class BlogEditor extends Component {

    constructor(props) {
        super(props);

        this.state = {
            buttonLoading: false,
            publishedEnabledLoading: false,
            publishedEnabled: false,
            blogs: [],
            blog: {lang: 'tr'},
            selectedBlogId: 0,
        }

        CKEditor.editorUrl = "/ckeditor419/ckeditor.js";

        this.blogs();
    }

    blogs = () => {

        BlogService.blogs()
            .then(
                response => {
                    let success = response.data && response.data.success === true;
                    if (success) {
                        const {blogs} = response.data ? response.data : [];
                        if (!!blogs.length) {
                            const blog = blogs[0];
                            const selectedBlogId = blog.id;
                            this.setState({blogs: blogs, blog: blog, selectedBlogId: selectedBlogId});
                        }
                    } else {
                        message.error(i18n.t('global_error'));
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    deleteBlog = () => {

        const {blog} = this.state;
        const {id} = blog;

        if (izBlank(id)) return;

        this.setState({buttonLoading: true})

        BlogService.delete({id})
            .then(
                response => {
                    this.setState({buttonLoading: false})
                    if (response.data.success === true) {
                        this.setState({blog: {lang: 'tr'}});

                        message.success(i18n.t('success'));
                    } else {
                        message.error(response.data.error)
                    }
                },
                error => {
                    this.setState({buttonLoading: false})
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)
                        message.error(i18n.t('login_expired'))
                    } else {
                        message.error(error.response.data.error)
                    }
                }
            )
    }

    newBlog = () => {
        this.setState({blog: {lang: 'tr'}});
    }

    publish = () => {

        const {blog} = this.state;
        const {subject, url, lang, content, coverContent} = blog;

        if (izBlank(subject) || izBlank(url) || izBlank(lang) || izBlank(content) || izBlank(coverContent)) return message.error(i18n.t('global_error'))

        this.setState({buttonLoading: true})

        BlogService.save(blog)
            .then(
                response => {
                    this.setState({buttonLoading: false})
                    if (response.data.success === true) {
                        this.setState({blog: response.data.blog});

                        message.success(i18n.t('success'));
                    } else {
                        message.error(response.data.error)
                    }
                },
                error => {
                    this.setState({buttonLoading: false})
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        message.error(error.response.data.error)
                    }
                }
            )
    }

    otherLangBlogSelected = (e) => {
        let {value, blogUrl} = e.target

        const {blog} = this.state;
        const {id} = blog;

        if (id !== value) {
            this.setState(prevState => ({
                blog: {
                    ...prevState.blog,
                    otherLangBlogId: value,
                    otherLangUrl: blogUrl
                }
            }))
        }
    }

    blogSelected = (e) => {

        let {value} = e.target

        BlogService.blogById({id: value})
            .then(
                response => {
                    let success = response.data && response.data.success === true;
                    if (success) {
                        const {blog} = response.data;
                        this.setState({
                            blog: blog ? blog : {},
                        });
                    } else {
                        message.error(i18n.t('global_error'));
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    handleSubjectChange = (e) => {
        const {name, value} = e.target

        let url = escapeTurkishCharsAndLowerForURL(value);

        this.setState(prevState => ({
            blog: {
                ...prevState.blog,
                [name]: value,
                url: url
            }
        }))
    }

    handleInputChange = (e) => {
        const {name, value} = e.target
        this.setState(prevState => ({
            blog: {
                ...prevState.blog,
                [name]: value
            }
        }))
    }

    handleEditorContent = (e) => {
        this.setState(prevState => ({
            blog: {
                ...prevState.blog,
                content: e.editor.getData()
            }
        }))
    }

    handleEditorCoverContent = (e) => {
        this.setState(prevState => ({
            blog: {
                ...prevState.blog,
                coverContent: e.editor.getData()
            }
        }))
    }

    customChangeLanguage = (lang, blogId) => {
        this.setState(prevState => ({
            blog: {
                ...prevState.blog,
                lang: lang
            }
        }))
    }

    togglePublishedEnabled = (publishedEnabled) => {
        setTimeout(function () {
            this.setState(prevState => ({
                publishedEnabled: publishedEnabled,
                blog: {
                    ...prevState.blog,
                    published: publishedEnabled
                }
            }))
        }.bind(this), 111);
    }

    render() {

        const {buttonLoading, publishedEnabledLoading, blog, blogs} = this.state;
        const {id, subject, url, otherLangBlogId, lang, content, coverContent, canonicalUrl, redirectUrl, metaKeys, metaDesc, published} = blog;

        let blogLang = !!lang ? lang : this.props.common.lang;
        let publishedEnabled = published;

        const config = {
            language: 'tr',
            height: 777,
        };

        const coverConfig = {
            language: 'tr',
            height: 333,
        };

        return (
            <>
                <section className="map-section pb-20">
                    <div className="container">
                        <div className="row justify-content-center mr-0 ml-0">
                            <div className="col-lg-8 text-center">
                                <div className="section-title">
                                    <h2>Easy Blog Editor</h2>
                                    {/*<p>Feel free to create new posts!</p>*/}
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mr-0 ml-0">
                            <div className="form-box-blog custom-ant-input-wrapper">
                                <div className="pt-15">
                                    <form method="POST" action="">
                                        <Blogs name="blogs"
                                               blogs={blogs}
                                               placeholder={i18n.t('blog')}
                                               selectedBlogId={id}
                                               onChange={this.blogSelected}/>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="blog-section pb-20">
                    <div className="container">
                        <div className="row justify-content-center mr-0 ml-0">
                            <div className="form-box-blog custom-ant-input-wrapper">
                                <div>
                                    <form method="POST" action="">
                                        <div>
                                            <Input type="text"
                                                   name="subject"
                                                   value={subject}
                                                   placeholder={i18n.t('contact_subject')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleSubjectChange}/>
                                        </div>
                                        <div>
                                            <Input type="text"
                                                   name="url"
                                                   value={url}
                                                   placeholder={i18n.t('url')}
                                                   autoComplete="off"
                                                   prefix={<LinkOutlined/>}
                                                   className="lowercase-input"
                                                   onInput={this.handleInputChange}/>
                                        </div>
                                        <div>
                                            <Blogs name="otherLangBlog"
                                                   blogs={blogs}
                                                   placeholder={i18n.t('otherLangUrl')}
                                                   selectedBlogId={otherLangBlogId}
                                                   currentBlogId={id}
                                                   onChange={this.otherLangBlogSelected}/>
                                        </div>
                                        <div className="pb-20">
                                            <span className="ml-15 mr-15">{i18n.t('lang')}</span>
                                            <Language
                                                skipCommon={true}
                                                customLang={blogLang}
                                                customIndex={id}
                                                customChangeLanguage={this.customChangeLanguage}
                                                hoverDisabled={true}/>

                                            <span className="ml-20 mr-20">{i18n.t('publish')}</span>
                                            <Switch
                                                onChange={this.togglePublishedEnabled}
                                                loading={publishedEnabledLoading}
                                                checked={publishedEnabled}
                                                checkedChildren={i18n.t('active')}
                                                unCheckedChildren={i18n.t('passive')}
                                            />
                                        </div>
                                        <div>
                                            {id && <PictureUploader blogId={id}/>}
                                        </div>
                                        <div>
                                            <CKEditor
                                                data={content}
                                                config={config}
                                                onChange={this.handleEditorContent}
                                            />
                                        </div>
                                        <div className="mt-20">
                                            <CKEditor
                                                data={coverContent}
                                                config={coverConfig}
                                                onChange={this.handleEditorCoverContent}
                                            />
                                        </div>
                                        <div className="mt-20">
                                            <Input type="text"
                                                   name="redirectUrl"
                                                   value={redirectUrl}
                                                   placeholder={i18n.t('redirectUrl')}
                                                   autoComplete="off"
                                                   prefix={<LinkOutlined/>}
                                                   className="lowercase-input"
                                                   onInput={this.handleInputChange}/>
                                        </div>
                                        <div className="mt-20">
                                            <Input type="text"
                                                   name="canonicalUrl"
                                                   value={canonicalUrl}
                                                   placeholder={i18n.t('canonicalUrl')}
                                                   autoComplete="off"
                                                   prefix={<LinkOutlined/>}
                                                   className="lowercase-input"
                                                   onInput={this.handleInputChange}/>
                                        </div>
                                        <div className="mt-20">
                                            <TextArea
                                                name="metaKeys"
                                                value={metaKeys}
                                                placeholder={i18n.t('metaKeys')}
                                                onInput={this.handleInputChange}
                                                autoSize={{minRows: 7, maxRows: 7}}/>
                                        </div>
                                        <div className="mt-20">
                                            <TextArea
                                                name="metaDesc"
                                                value={metaDesc}
                                                placeholder={i18n.t('metaDesc')}
                                                onInput={this.handleInputChange}
                                                autoSize={{minRows: 7, maxRows: 7}}/>
                                        </div>

                                        <div className="form-group mt-20">
                                            <div className="row justify-content-between pr-15 pl-15">
                                                <div>
                                                    <Button
                                                        className="custom-button"
                                                        type="button"
                                                        onClick={this.publish}
                                                        loading={buttonLoading}>
                                                        {i18n.t('save')}
                                                    </Button>
                                                </div>
                                                <div>
                                                    <Popconfirm
                                                        title="Silmek istediğinizden emin misin??? Dikkat et giderse gelmez..."
                                                        onConfirm={this.deleteBlog}
                                                        onCancel={() => {
                                                            return 1
                                                        }}
                                                        okText="Evet"
                                                        cancelText="Hayırrr"
                                                    >
                                                        <Button
                                                            className="custom-button"
                                                            type="button"
                                                            onClick={() => {
                                                                return 1
                                                            }}
                                                            loading={buttonLoading}
                                                        >
                                                            {i18n.t('deleteBlog')}
                                                        </Button>
                                                    </Popconfirm>
                                                </div>
                                                <div>
                                                    <Button
                                                        className="custom-button"
                                                        type="button"
                                                        onClick={this.newBlog}
                                                    >
                                                        {i18n.t('addNewBlog')}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogEditor);